export const appVersion = '1.0.0';
export const appTitle = 'Token Creator by DEXTools';
export const externalLink = true;
